// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"626":"26eb41b3","781":"55d02f4b","957":"cfd4d849"}[chunkId] + ".css";
};